export const USER_ID = 'userId';
export const ALGO_ID = 'algoId';
export const TOKEN = 'token';
export const ACTIVE_PAGE = 'activePage';
export const ACTIVE_PAGE_OPTIONS_SPREADS_LEGS =
  'ACTIVE_PAGE_OPTIONS_SPREADS_LEGS';
export const PAYMENT_PROCESSING_RAZORPAY = 'PAYMENT_PROCESSING_RAZORPAY';
export const PAYMENT_PROCESSING_RETRY_DURATION_RAZORPAY =
  'PAYMENT_PROCESSING_RETRY_DURATION_RAZORPAY';
export const ALGO_TABLE_SORT = 'algo_table_sort';
export const ALGO_EDIT_CLIENT_ID_SHOW = 'ALGO_EDIT_CLIENT_ID_SHOW';
export const ALGO_TABLE_FILTER = 'algo_table_filter';
export const ALGO_TABLE_POSITION_STATE = 'ALGO_TABLE_POSITION_STATE';
export const TOTAL_LTP_PERIOD = 'TOTAL_LTP_PERIOD';
export const NOTIFICATIONS_POSITION = 'NOTIFICATIONS_POSITION';

export const SIGNALS_LIST_TABLE_POSITION_STATE =
  'SIGNALS_LIST_TABLE_POSITION_STATE';

export const SIGNALS_LIST_TABLE_SORT = 'SIGNALS_LIST_TABLE_SORT';

export const ANNOUNCEMENTS_DISMISSED = 'ANNOUNCEMENTS_DISMISSED';

export const ALGO_BULK_ERROR_RETRY_POSITION_STATE =
  'ALGO_BULK_ERROR_RETRY_POSITION_STATE';
